"use client";

import { useMemo } from "react";
import { useTranslations } from "next-intl";
import { StepSelector } from "../StepSelector";
import { MdOutlineSpeakerGroup, MdTab } from "react-icons/md";
import { AiFillTag } from "react-icons/ai";
import { LuSearch } from "react-icons/lu";
import { IoMdAdd } from "react-icons/io";
import { Tour } from "nextstepjs";
import { Box, Text } from "@chakra-ui/react";
import { WistiaPlayer } from "@wistia/wistia-player-react";
import { WISTIA_MEDIA_ID } from "../../GroupCandidates/constant";
import { POINTER_PADDING, POINTER_RADIUS } from "../constant";

export const talentPoolSelectors = {
  multiLayout: new StepSelector("multi-layout"),
  ungroupedResumes: new StepSelector("ungrouped-resumes"),
  searchResumes: new StepSelector("search-resumes"),
  newResume: new StepSelector("new-resume"),
  newGroup: new StepSelector("new-group"),
};

export const useTalentPoolTour = (): Tour => {
  const t = useTranslations("space.talent_pool.feature_tour");
  return useMemo(
    () => ({
      tour: "talent_pool",
      steps: [
        {
          icon: <MdTab />,
          title: t("step1.title"),
          showControls: true,
          showSkip: true,
          side: "bottom",
          selector: talentPoolSelectors.multiLayout.selector,
          content: t("step1.content"),
          pointerPadding: POINTER_PADDING,
          pointerRadius: POINTER_RADIUS,
        },
        {
          icon: <LuSearch />,
          title: t("step2.title"),
          showControls: true,
          showSkip: true,
          side: "right",
          selector: talentPoolSelectors.searchResumes.selector,
          content: t("step2.content"),
          pointerPadding: POINTER_PADDING,
          pointerRadius: POINTER_RADIUS,
        },
        {
          icon: <AiFillTag />,
          title: t("step3.title"),
          showControls: true,
          showSkip: true,
          side: "right",
          selector: talentPoolSelectors.ungroupedResumes.selector,
          content: t("step3.content"),
          pointerPadding: POINTER_PADDING,
          pointerRadius: POINTER_RADIUS,
        },
        {
          icon: <IoMdAdd />,
          title: t("step4.title"),
          showControls: true,
          showSkip: true,
          side: "bottom-right",
          selector: talentPoolSelectors.newResume.selector,
          content: t("step4.content"),
          pointerPadding: POINTER_PADDING,
          pointerRadius: POINTER_RADIUS,
        },
        {
          icon: <MdOutlineSpeakerGroup />,
          title: t("step5.title"),
          showControls: true,
          showSkip: true,
          side: "bottom-right",
          selector: talentPoolSelectors.newGroup.selector,
          content: (
            <Box>
              <Text mb={2} textStyle="sm">
                {t("step5.body_primary")}
              </Text>
              <Text color="neutral.500" mb={2} textStyle="xs">
                {t("step5.watch_more")}
              </Text>
              <WistiaPlayer
                autoplay
                qualityMin={720}
                mediaId={WISTIA_MEDIA_ID.talentPool}
                aspect={16 / 9}
              />
            </Box>
          ),
          pointerPadding: POINTER_PADDING,
          pointerRadius: POINTER_RADIUS,
        },
      ],
    }),
    [t],
  );
};
